import styled from 'styled-components'
import { omniaTheme } from '../../theme/omniaTheme'

// ============================================================
// Page-level wrapper
// ============================================================

export const ValuationContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 14mm 14mm 14mm 14mm;
  box-sizing: border-box;

  @media print {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 14mm 14mm 14mm 14mm !important;
  }
`

// ============================================================
// Hero value block (white card centered)
// ============================================================

export const HeroCard = styled.div`
  background: ${omniaTheme.colors.cardBg};
  width: 100%;
  min-height: 160px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;

  @media print {
    background: ${omniaTheme.colors.cardBg} !important;
    width: 100% !important;
    min-height: 160px !important;
    padding: 32px 24px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 12px !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroLabel = styled.span`
  font-family: ${omniaTheme.fonts.label};
  font-size: 10px;
  font-weight: ${omniaTheme.fontWeights.light};
  letter-spacing: ${omniaTheme.letterSpacing.wide};
  color: ${omniaTheme.colors.textLabel};
  text-transform: uppercase;

  @media print {
    font-family: ${omniaTheme.fonts.label} !important;
    font-size: 10px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    letter-spacing: ${omniaTheme.letterSpacing.wide} !important;
    color: ${omniaTheme.colors.textLabel} !important;
    text-transform: uppercase !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroValue = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 48px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1;
  text-align: center;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 48px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1 !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeroRange = styled.div`
  font-family: ${omniaTheme.fonts.body};
  font-size: 13px;
  font-weight: ${omniaTheme.fontWeights.normal};
  color: ${omniaTheme.colors.textMuted};
  text-align: center;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 13px !important;
    font-weight: ${omniaTheme.fontWeights.normal} !important;
    color: ${omniaTheme.colors.textMuted} !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// Section spacing helpers
// ============================================================

export const SectionGapLarge = styled.div`
  height: 32px;

  @media print {
    height: 32px !important;
  }
`

export const SectionGapMedium = styled.div`
  height: 16px;

  @media print {
    height: 16px !important;
  }
`

export const SectionGapSmall = styled.div`
  height: 8px;

  @media print {
    height: 8px !important;
  }
`

// ============================================================
// Subhead + description
// ============================================================

export const Subhead = styled.h3`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${omniaTheme.fontWeights.medium};
  color: ${omniaTheme.colors.black};
  margin: 0;
  letter-spacing: ${omniaTheme.letterSpacing.tight};

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${omniaTheme.fontWeights.medium} !important;
    color: ${omniaTheme.colors.black} !important;
    margin: 0 !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Description = styled.p`
  font-family: ${omniaTheme.fonts.body};
  font-size: 10px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.textMuted};
  line-height: 1.5;
  margin: 0;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 10px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.textMuted} !important;
    line-height: 1.5 !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// Strips row
// ============================================================

export const StripsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 16px !important;
  }
`

export const Strip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

// Track + fill, stacked using a parent track with an absolutely-positioned fill.
export const StripBarTrack = styled.div`
  position: relative;
  width: 100%;
  height: 3px;
  background: ${omniaTheme.colors.purple100};
  margin-bottom: 16px;

  @media print {
    position: relative !important;
    width: 100% !important;
    height: 3px !important;
    background: ${omniaTheme.colors.purple100} !important;
    margin-bottom: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StripBarFill = styled.div<{
  $percent: number
  $variant: 'avm' | 'expert'
  $color?: string
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  width: ${({ $percent }) => `${Math.max(0, Math.min(100, $percent))}%`};
  background: ${({ $variant, $color }) =>
    $color ||
    ($variant === 'expert'
      ? omniaTheme.colors.purple900
      : omniaTheme.colors.purple500)};

  @media print {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    height: 3px !important;
    width: ${({ $percent }) =>
      `${Math.max(0, Math.min(100, $percent))}%`} !important;
    background: ${({ $variant, $color }) =>
      $color ||
      ($variant === 'expert'
        ? omniaTheme.colors.purple900
        : omniaTheme.colors.purple500)} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StripLabel = styled.span`
  font-family: ${omniaTheme.fonts.label};
  font-size: 10px;
  font-weight: ${omniaTheme.fontWeights.normal};
  letter-spacing: ${omniaTheme.letterSpacing.wide};
  color: ${omniaTheme.colors.text};
  text-transform: uppercase;
  margin-bottom: 6px;

  @media print {
    font-family: ${omniaTheme.fonts.label} !important;
    font-size: 10px !important;
    font-weight: ${omniaTheme.fontWeights.normal} !important;
    letter-spacing: ${omniaTheme.letterSpacing.wide} !important;
    color: ${omniaTheme.colors.text} !important;
    text-transform: uppercase !important;
    margin-bottom: 6px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StripValue = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 18px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1.1;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 18px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1.1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StripRange = styled.div`
  font-family: ${omniaTheme.fonts.body};
  font-size: 9px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.textMuted};
  margin-top: 4px;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 9px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.textMuted} !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// Methodology paragraph
// ============================================================

export const MethodologyParagraph = styled.p`
  font-family: ${omniaTheme.fonts.body};
  font-size: 10px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.text};
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 10px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.text} !important;
    line-height: 1.6 !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
